import React, { FC } from "react";
import { Fade } from "react-awesome-reveal";
import classNames from "classnames";
import { DEFAULT_FADE_DURATION } from "@app/constants";
import { Review as ReviewInterface } from "../../models";
import { Carousel } from "./components/carousel/Carousel";

type Props = {
  reviews: ReviewInterface[];
};

export const ImageReviews: FC<Props> = ({ reviews }) => (
  <div
    className={classNames(
      "mt-20 h-[576px]",
      "lg:mt-25",
      "xl:mt-40",
      "xxl:h-[945px]",
    )}
  >
    <Fade duration={DEFAULT_FADE_DURATION} triggerOnce>
      <Carousel reviews={reviews} />
    </Fade>
  </div>
);
